var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Icons } from 'src/ui/components/Icons/Icons';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { COLORS } from 'src/shared/styles/colors';
import styles from './checkbox.module.scss';
export var Checkbox = function (props) {
    var _a;
    var label = props.label, checked = props.checked, onChange = props.onChange, required = props.required, className = props.className;
    var handleToggle = function () {
        var event = {
            target: {
                checked: !checked,
            },
        };
        onChange(event);
    };
    var checkboxClassName = classNames(styles.checkboxWrapper, className);
    var iconWrapperClassName = classNames(styles.checkboxIconWrapper, (_a = {},
        _a[styles.checked] = checked,
        _a));
    return (_jsxs("div", __assign({ className: checkboxClassName, onClick: handleToggle }, { children: [_jsx("div", __assign({ className: iconWrapperClassName }, { children: checked && _jsx(Icons, { icon: E_ICONS.CHECK, color: COLORS.WHITE, className: styles.checkIcon }) })), _jsxs("span", __assign({ className: styles.checkboxLabel }, { children: [label, required && _jsx("span", __assign({ className: styles.requiredAsterisk }, { children: " *" }))] }))] })));
};
